import im from 'immutable';

const Identity = im.Record({
  modals: [],
});

function getModalById(state, id) {
  return state.modals.filter(modal => modal.id === id)[0] || null;
}

export default (state = new Identity(), action) => {
  switch (action.type) {
    case 'MODAL_EMIT': {
      if (getModalById(state, action.modal.key) === null) {
        return new Identity({
          modals: [action.modal, ...state.modals],
        });
      }
      return state;
    }

    case 'MODAL_DISMISS':
      if (action.id) {
        return new Identity({
          modals: state.modals.filter(modal => modal.key !== action.id),
        });
      }
      if (action.scope) {
        return new Identity({
          modals: state.modals.filter(modal => modal.props.scope !== action.scope),
        });
      }
      return state;

    default:
      return state;
  }
};
